
export const sendDataLayerEvent = (eventName, props) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...props
    });
};

export const trackHeapEvent = (eventName, eventProperties) => {
  if (window?.heap) {
    window.heap.track(eventName, eventProperties);
  }
};
